// Tournament module types and enums

export enum TOURNAMENT_KNOCKOUT_FORMATS {
  KNOCKOUT_WITH_BYES = 'knockout_with_byes',
  SINGLE_ELIMINATION = 'single_elimination',
}

export enum TOURNAMENT_KNOCKOUT_STAGES {
  ELIMINATION = 'elimination',
  QUALIFIER = 'qualifier',
  QUARTERFINAL = 'quarterfinal',
  SEMIFINAL = 'semifinal',
  FINAL = 'final',
  THIRDPLACE = 'thirdplace',
}
